// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1A1cg","header":"ReportDetails_header__387vc","title":"ReportDetails_title__fZQsI","left":"ReportDetails_left__3Srps"};